export default __webpack_public_path__ + "static/media/g.e7c69386.png";